module.exports = __webpack_public_path__ + "img/fault-icon.3849782b.png";